// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d9521470","223":"4846749e","239":"958848b2","389":"8ee302b5","397":"d0675980","453":"e1fe6ef3","488":"138a10b7","732":"f7660174","977":"201f52a8"}[chunkId] + ".chunk.js";
};